<template>
  <div class="sp_serviceList">
    <heade-title :title="title"></heade-title>

    <div class="sp_service_card">
      <el-row :gutter="1">
        <el-col :span="8"
                v-for="val in serviceCard"
                :key="val.id">
          <div class="card_item">
            <span class="card_item_img"><img :src="val.url"
                   alt="img"></span>
            <span class="card_item_name">{{val.name}}</span>
            <span class="card_item_num">{{val.num}}</span>
          </div>
        </el-col>
      </el-row>
    </div>

    <div class="sp_service_table">
      <el-row>
        <el-col></el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import headeTitle from '../../components/headeTitle.vue'
export default {
  components: { headeTitle },
  name: 'serviceList',
  data () {
    return {
      title: "Service List",
      serviceCard: [
        { id: 1, name: '已核销的服务总数', num: '56', url: require('../../assets/img/haveCancel.png') },
        { id: 2, name: '有效服务总数', num: '13', url: require('../../assets/img/haveValid.png') },
        { id: 3, name: '失效服务总数', num: '18', url: require('../../assets/img/haveLose.png') },
      ]
    }
  }
}
</script>

<style scoped lang="scss">
.sp_serviceList {
  width: 100%;
  .sp_service_card {
    width: 100%;
    .card_item {
      width: 100%;
      display: flex;
      background: #fff;
      padding: 20px 30px;
      align-items: center;
      justify-content: flex-start;
      box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.08);
      .card_item_img {
        width: 54px;
        height: 54px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .card_item_name {
        font-size: 18px;
        color: #2b2b2b;
        line-height: 25px;
        margin-left: 20px;
      }
      .card_item_num {
        font-size: 32px;
        font-weight: bold;
        color: #2b2b2b;
        line-height: 37px;
        flex: 1;
        text-align: right;
      }
    }
  }
  .sp_service_table {
    width: 100%;
  }
}
</style>